import { Link, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store";
import { selectRep } from "../../redux-store/rep/repSlice";
import { number, string } from "yup";
import { toInteger } from "lodash";
import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";

const Footer = () => {
  //for bind user details
  const dispatch = useAppDispatch();
  const { data: rep, status } = useAppSelector(selectRep);
  const [url, setUrl] = useState("");
  const [searchParams] = useSearchParams();

  // Ensure the phone number is a string
  const phoneNumber1 = toInteger(rep!.repPhone);
  function formatPhoneNumber(phoneNumber: number) {
    // Ensure the phone number is a string
    const cleaned = ("" + phoneNumber).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return null;
  }
  const formattedPhoneNumber = formatPhoneNumber(phoneNumber1);

  const footerLinks = [
    {
      title: "Explore",
      links: [
        { label: "Home", href: "/home/" + url },
        { label: "What's Included", href: "/whatsincluded/" + url },
        { label: "Testimonial", href: "/testimonial/" + url },
        { label: "Pricing", href: "/pricing/" + url },
        { label: "Contact Us", href: "/contactus/" + url },
      ],
      classes: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ms-auto",
    },
  ];
  const socialIcons = [
    {
      iconClass: "fab fa-facebook-f text-white",
      link: "https://www.facebook.com/people/UCES-Protection-Plan/100090028402681/",
      ariaLabel: "facebook",
    },
    {
      iconClass: "fab fa-instagram text-white",
      link: "https://www.instagram.com/uweprotectionplan/",
      ariaLabel: "Instagram",
    },
  ];

  // start Testimonial 
  const Testimonial = [
    {
      backgroundColor: "#825EFF",
      rating: "- Michael H ",
      text: "The Protection Plan has been a game-changer. UWE empowers families with financial literacy, helps us save, become better homebuyers, and educate our kids on avoiding past mistakes. Their scholarships for youth show they’re truly for the people.",

    },
    {
      backgroundColor: "#2FB705",
      rating: "- Stephanie C",
      text: "In September 2020, my husband and I wanted to buy a home and were introduced to the program. It helped increase my credit score, remove most of our student loans, update late payments, and remove collections. We got approved for a new construction home.",
    },
    {
      backgroundColor: "#F28028",
      rating: "- Stacy Record",
      text: "I absolutely love this company!  My credit score has improved significantly. I'm especially grateful for the assistance in getting multiple negative items removed from my credit report. The positive changes have truly made a difference. Thank you for everything!",
    },
    {
      backgroundColor: "#73CEFF",
      rating: "- Milton S",
      text: "I am absolutely thrilled with the improvement in my credit score, and I owe a huge thank you to Protection Plan for their invaluable help and support. Their guidance was instrumental in helping me achieve this financial milestone. I couldn't be happier with the results and the top-notch service provided by Protection Plan!  ",
    },
    {
      backgroundColor: "#825EFF",
      rating: "- Jasmine M",
      text: "I want to say that I love this program. When I started, I was trying to get my student loans removed and I got them removed within 2 months in joining this Awesome amazing company.  I'm a testament to this program and how it works.   Thank you very much",

    },
    {
      backgroundColor: "#2FB705",
      rating: "- Melissa B",
      text: "It’s such a true blessing to see a Federal Student Loan come off my Credit Report. Wow!!! I am excited and can’t wait to see more. That's not the only thing, but its Huge!!! Yall are Awesome!!!",
    },
    {
      backgroundColor: "#F28028",
      rating: "- Julie Simmons",
      text: "Protection Plan has provided me with the BEST results ever! Words cannot express my sincere appreciation, I am overly satisfied with the respect, customer service, and their willingness to assist me! Thank you for dedicating your time to help my family and I .",
    },
    {
      backgroundColor: "#73CEFF",
      rating: "- Twana Graham",
      text: "I'd like to take this time out to say: THANK YOU Protection Plan! I was skeptical about working in the beginning. I've worked with several restoration companies, spending tons of money only to have been let down. I must say: I am impressed with my progress in such a short time.",
    },

    {
      backgroundColor: "#825EFF",
      rating: "- Tati DeShaun",
      text: "I'm thrilled to share my latest results and confirm that my payment will be ready on time! It's been a fantastic journey improving my credit score to a 650, and I couldn't be happier to have your team by my side. Thank you for all the support!",

    },
    {
      backgroundColor: "#2FB705",
      rating: "- Andrea Turner",
      text: "As a single mother of 3 I use to have to go to buy here pay here cat lots and private landlords due to poor credit and bad financial management! The services in the protection plan helped me to learn to budget, save money and eliminate debt! I was also able to improve my credit score.",
    },
    {
      backgroundColor: "#F28028",
      rating: "- Milton Sims",
      text: "I am absolutely thrilled with the improvement in my credit score, and I owe a huge thank you to Protection Plan - UCES for their invaluable help and support. Their guidance was instrumental in helping me achieve this financial milestone. I couldn't be happier with the results and the top-notch service",
    },
    {
      backgroundColor: "#73CEFF",
      rating: "- Almany Jalloh ",
      text: "I just want to thank the Protection Plan program for taking my life journey to a higher level. I never thought I could achieve results. The Protection Plan Team was very helpful and quick to respond to every detailed question asked by me. I am blessed to be a part of this program and recommend Protection Plan to any and everyone!",
    },
  ];
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 6000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const sliderRef = useRef(null);
  // end Testimonial 

  useEffect(() => {
    setUrl(
      rep!.repFolder +
      (searchParams.toString() != "" ? "?" + searchParams.toString() : "")
    );
  }, [url, rep]);

  return (
    <div className="footer-style-one theme-basic-footer position-relative bg-globalblue">
      <div className="container-fluid">
        <div className="inner-wrapper">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 footer-intro mt-40 mb-40 align-self-center">
              {/* <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 offset-0 offset-sm-0 offset-md-0 offset-lg-1 offset-xl-1 footer-intro mt-40 mb-40 align-self-center"> */}
              {/* <div className="logo">
                <Link to="/">
                  <img
                    src="/images/logo/UCES_PP_Logo_White.webp"
                    alt="logo footer"
                    className="h-auto w-auto"
                  />
                </Link>
              </div> */}
              <div className="row align-items-center px-4">
                <div className="col-lg-12 col-md-12">
                  <h2 className="fw-bold footer-title fs-2 ps-4 text-white fw-500 mt-20">
                    Testimonials
                  </h2>
                  {/* /.title-style-one */}
                </div>
                <div className="col-lg-12 col-md-12">
                  <div className="feedback_slider_one custom slider-container">
                    <Slider {...settings} ref={sliderRef} arrows={false}>
                      {Testimonial.map((item, index) => (
                        <div className="item" key={index}>
                          <div className="feedback-block-one pt-25 align-items-end d-sm-flex">
                            <div className="text-wrapper w-100 h-auto pb-5">
                              <div
                                className="icon d-flex align-items-center justify-content-center rounded-circle mb-0"
                                style={{ backgroundColor: item.backgroundColor }}
                              >
                                <img src="/images/icon/icon_07.svg" alt="img" />
                              </div>
                              <div className="rating h5 mt-2 fw-bold tx-dark">
                                {item.rating}
                              </div>
                              <p className="pt-0 pb-0">{item.text}</p>
                              {/* <h6>
                                {item.author}
                              </h6> */}
                            </div>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                  {/* /.feedback_slider_one */}
                </div>
              </div>
              {/* /.container */}

              {/* /.inner-content */}
              {/* <span className="footer-title h-5 text-white fw-500 mt-20 mb-0">
                Disclaimer :
              </span>
              <p className="fs-14 mb-0 fw-normal text-white text-justify px-2">
                UCES does not guarantee the removal or deletion of any item
                reported on your credit profile and cannot guarantee a specific
                outcome for credit restoration. Results are contingent on many
                factors, including client participation. We will work to provide
                you with the best results possible.
              </p> */}
            </div>
            {/* End .col-xl-3 */}
            <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 footer-intro mt-0 p-5 bg-warning border-custom-radius">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ms-auto">
                  <h5 className="footer-title text-white fw-500">Explore</h5>
                  <ul className="footer-nav-link style-none">
                    <li>
                      <Link to={"/home/" + url}>Home</Link>
                    </li>
                    <li>
                      <Link to={"/whatsincluded/" + url}>What's Included</Link>
                    </li>
                    <li>
                      <Link to={"/testimonial/" + url}>Testimonial</Link>
                    </li>
                    {url !== "" ? (
                      <li>
                        <Link to={"/ppquizhome/" + url}>Financial Quiz</Link>
                      </li>
                    ) : (
                      ""
                    )}
                    <li>
                      <Link to={"/faq/" + url}>FAQ</Link>
                    </li>
                    <li>
                      <Link to={"/contactus/" + url}>Contact Us</Link>
                    </li>
                  </ul>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <h5 className="footer-title text-white fw-500">Contact Us</h5>
                  <p className="fs-17 text-white">
                    {rep!.repId == "" ? "PO Box 130, Farmington, MI 48332" : ""}
                  </p>
                  <a
                    href={"mailto:" + rep!.repEmail}
                    className="email tran3s fs-20 text-white d-flex flex-wrap"
                  >
                    <img
                      src="/images/icon/icon_email.svg"
                      alt=""
                      className="me-2 h-auto w-auto"
                    />
                    {rep!.repEmail}
                  </a>
                  <a
                    href={"tel:+" + rep!.repPhone}
                    className="mobile tran3s fs-20 mt-0 mb-20 text-white d-flex flex-wrap"
                  >
                    <img
                      src="/images/icon/icon_talk.svg"
                      alt=""
                      className="me-2 h-auto w-auto"
                    />
                    {formattedPhoneNumber}
                  </a>

                  <ul className="d-flex social-icon style-none">
                    {socialIcons.map((icon, index) => (
                      <li key={index}>
                        <a
                          href={icon.link}
                          target="_blank"
                          aria-label={icon.ariaLabel}
                          rel="noopener noreferrer"
                        >
                          <i className={icon.iconClass} />
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            {/* End menu data */}
          </div>
          <div className="bottom-footer mt-0 row border-top border-1 align-items-center justify-content-center">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 offset-0 offset-sm-0 offset-md-0 offset-lg-0 offset-xl-1 ">
              <p className="copyright text-center text-sm-center text-md-center text-lg-center text-xl-start text-white m0">
                ©&nbsp;Copyright&nbsp;{new Date().getFullYear()}
                <a target="_blank" rel="noopener noreferrer" href="/">
                  &nbsp;Protection Plan
                </a>
              </p>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 px-4">
              <ul
                style={{ listStyleType: "disc" }}
                className="d-flex d-sm-block fw-normal d-md-flex d-lg-flex d-xl-flex flex-wrap footer-nav-link style-none justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-end"
              >
                <li>
                  <Link
                    className="pe-4"
                    to={"/privacypolicy/" + url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    className="pe-4"
                    to={"/termsofuse/" + url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms of use
                  </Link>
                </li>
                <li>
                  <Link
                    className="pe-4"
                    to={"/accessiblitystatement/" + url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Accessibility Statement
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          {/* /.inner-wrapper */}
        </div>
      </div>
      {/* /.footer-style-one */}
    </div>
  );
};

export default Footer;
